import { render, staticRenderFns } from "./DevicesCompact.vue?vue&type=template&id=507946e4&scoped=true"
import script from "./DevicesCompact.vue?vue&type=script&lang=js"
export * from "./DevicesCompact.vue?vue&type=script&lang=js"
import style0 from "./DevicesCompact.vue?vue&type=style&index=0&id=507946e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507946e4",
  null
  
)

export default component.exports